import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import "leaflet/dist/leaflet.css";
import { initSentry } from "./lib/sentry";

// Initialize error tracking and monitoring
initSentry();

createRoot(document.getElementById("root")!).render(<App />);
